window.TRADEIN_DATA_ESPECIAL =
[
  {
    "Modelo": "iPhone 15 - 128GB",
    "Precio recibido": 435,
    "Precio venta": 520,
    "Batería en mantenimiento": 90,
    "Tapa trasera quebrada": 70,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 - 256GB",
    "Precio recibido": 465,
    "Precio venta": 585,
    "Batería en mantenimiento": 90,
    "Tapa trasera quebrada": 70,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Plus - 128GB",
    "Precio recibido": 455,
    "Precio venta": 600,
    "Batería en mantenimiento": 95,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Plus - 256GB",
    "Precio recibido": 485,
    "Precio venta": 650,
    "Batería en mantenimiento": 95,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro - 128GB",
    "Precio recibido": 570,
    "Precio venta": 680,
    "Batería en mantenimiento": 95,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro - 256GB",
    "Precio recibido": 625,
    "Precio venta": 780,
    "Batería en mantenimiento": 95,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro Max - 256GB",
    "Precio recibido": 675,
    "Precio venta": 795,
    "Batería en mantenimiento": 110,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro Max - 512GB",
    "Precio recibido": 715,
    "Precio venta": 890,
    "Batería en mantenimiento": 110,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro Max - 1TB",
    "Precio recibido": 755,
    "Precio venta": 950,
    "Batería en mantenimiento": 110,
    "Tapa trasera quebrada": 90,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 - 128GB",
    "Precio recibido": 570,
    "Precio venta": 690,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 - 256GB",
    "Precio recibido": 595,
    "Precio venta": 755,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16e - 128GB",
    "Precio recibido": 335,
    "Precio venta": "",
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 16e - 256GB",
    "Precio recibido": 400,
    "Precio venta": "",
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 16 Plus - 128GB",
    "Precio recibido": 630,
    "Precio venta": 755,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro - 128GB",
    "Precio recibido": 700,
    "Precio venta": 880,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro - 256GB",
    "Precio recibido": 725,
    "Precio venta": 930,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max - 256GB",
    "Precio recibido": 850,
    "Precio venta": 1000,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max - 512GB",
    "Precio recibido": 880,
    "Precio venta": 1085,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Nuevo Single-Sim - 128GB",
    "Precio recibido": "",
    "Precio venta": 760,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Nuevo E-Sim - 128GB",
    "Precio recibido": "",
    "Precio venta": 845,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Nuevo Single-Sim - 128GB",
    "Precio recibido": "",
    "Precio venta": 865,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Nuevo E-Sim - 128GB",
    "Precio recibido": "",
    "Precio venta": 1055,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Nuevo Single-Sim - 128GB",
    "Precio recibido": "",
    "Precio venta": 1185,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Nuevo Single-Sim - 256GB",
    "Precio recibido": "",
    "Precio venta": 1270,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max Nuevo E-Sim - 256GB",
    "Precio recibido": "",
    "Precio venta": 1235,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max Nuevo Single-Sim - 256GB",
    "Precio recibido": "",
    "Precio venta": 1360,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max Nuevo E-Sim - 512GB",
    "Precio recibido": "",
    "Precio venta": 1450,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Nuevo E-Sim - 256GB",
    "Precio recibido": "",
    "Precio venta": 1095,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro Nuevo E-Sim - 256GB",
    "Precio recibido": "",
    "Precio venta": 1405,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max Nuevo E-Sim - 256GB",
    "Precio recibido": "",
    "Precio venta": 1510,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max Nuevo E-Sim - 512GB",
    "Precio recibido": "",
    "Precio venta": 1785,
    "Batería en mantenimiento": "",
    "Tapa trasera quebrada": "",
    "Tipo": "venta"
  }
];